import React, { useState, Fragment } from 'react';
import { Input, Row, Col, Card, CardBody, Button } from 'reactstrap';
import classnames from 'classnames';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { connect } from 'react-redux';
import { postAPI_GPT_Query } from '../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faCopy } from '@fortawesome/free-solid-svg-icons';
import { sessionTerminated } from 'redux-oidc';
import data from '../../../../../constants/menu';
const KnowledgeSearch = ({ propertyId }) => {
  const [search, setSearch] = useState('');
  const [spinnerStatus, setSpinnerStatus] = useState('default');
  const [result, setResult] = useState(
    sessionStorage.getItem(propertyId + '_knowledgeSearch')
      ? JSON.parse(sessionStorage.getItem(propertyId + '_knowledgeSearch'))
      : []
  );
  const [searchState, setSearchState] = useState('search');

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setSearchState('search');
  };

  const handleSubmit = () => {
    setSpinnerStatus('processing');
    setSearchState('search');
    let body = {
      conversationId: '3',
      propertyName: getGroupID(),
      propertyId: propertyId,
      language: 'en-US',
      modelName: 'gpt-3.5-turbo-0125',
      suffix: '',
      q: search,
    };
    AxiosAPI({
      method: 'post',
      url: `${postAPI_GPT_Query}/query`,
      data: body,
    }).then((res) => {
      if (res.data.content !== undefined) {
        console.log(res.data);
        let lst = result;
        lst.push(res.data);
        lst.reverse();
        setResult(lst);
        console.log(lst);
        sessionStorage.setItem(
          propertyId + '_knowledgeSearch',
          JSON.stringify(lst)
        );
        setSpinnerStatus('success');
        setSearchState('success');
        setSearch('');
      }
    });
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };
  return (
    <Fragment>
      <Card className="card-box">
        <CardBody className="mt-0">
          <Row>
            <Colxx xxs="12" className="mb-2 col-sm-12 col-md-12 pr-0">
              <div className="input-group" style={{ display: 'flex' }}>
                <Input className='input_sty'
                  type="text"
                  style={{ width: '80%' }}
                  value={search}
                  placeholder={' Enter a search phrase…'}
                  onChange={handleSearch}
                  onKeyDown={handleKeyDown}
                />

                <button
                  className="item-center btn-search input_sty"
                  type="button"
                  onClick={handleSubmit}
                  style={{ width: '10%', marginRight: '10px' }}
                >
                  <FontAwesomeIcon className='fasearch'
                    icon={faSearch}
                    size="md"

                  />
                </button>

              </div>
            </Colxx>
            {/* <Col md={12} className="mb-3 text-right">
              <Button
                color="primary"
                onClick={handleSubmit}
                className={`btn-multiple-state ${classnames({
                  'show-spinner': spinnerStatus === 'processing',
                  'show-success': spinnerStatus === 'success',
                  'show-fail': spinnerStatus === 'fail',
                })}`}
              >
                <span className="spinner d-inline-block">
                  <span className="bounce1" />
                  <span className="bounce2" />
                  <span className="bounce3" />
                </span>
                <span className="icon success">
                  <i className="simple-icon-check" />
                </span>
                <span className="icon fail">
                  <i className="simple-icon-exclamation" />
                </span>
                <span className="label">Search</span>
              </Button>
            </Col> */}
            <div className="knowledge-search-card">
              {result !== undefined && result.length > 0 && (
                <Fragment>
                  {result.map((r) => (
                    <Colxx
                      xxs="11"
                      style={{ border: '1px solid #c8c3c3' }}
                      className="m-3"
                    >
                      <CopyToClipboard text={r.content}>
                        <Button
                          outline
                          size="xs"
                          style={{
                            float: 'right',
                            color: 'grey',
                            border: 'none',
                          }}
                          className="my-2"
                        >
                          <FontAwesomeIcon icon={faCopy}></FontAwesomeIcon>
                        </Button>
                      </CopyToClipboard>
                      <div className="m-3">{r.content}</div>
                    </Colxx>
                  ))}
                </Fragment>
              )}
            </div>
          </Row>
        </CardBody>
      </Card>
    </Fragment>
  );
};

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return { propertyId };
};

export default connect(mapStateToProps, {})(KnowledgeSearch);
